import React, { useEffect, useMemo, useState } from 'react';
import { trackEventIfConsented } from './analyticsConsent';
import {
  AMAZON_STORE_PREFERENCE_KEY,
  AMAZON_STORE_UPDATED_EVENT,
  AMAZON_SUPPORTED_REGIONS,
  clearAmazonStorePreference,
  getAmazonStoreDetails,
  getAmazonStoreResolution,
  setAmazonStorePreference,
} from './amazonAffiliate';

const AUTO_VALUE = 'AUTO';

const getAmazonStoreState = () => getAmazonStoreResolution(null);

const AmazonStoreSelector = () => {
  const [amazonStoreState, setAmazonStoreState] = useState(getAmazonStoreState);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const syncAmazonStoreState = () => {
      setAmazonStoreState(getAmazonStoreState());
    };

    const handleStoreUpdated = () => {
      syncAmazonStoreState();
    };

    const handleStorage = event => {
      if (event.key === AMAZON_STORE_PREFERENCE_KEY) {
        syncAmazonStoreState();
      }
    };

    window.addEventListener(AMAZON_STORE_UPDATED_EVENT, handleStoreUpdated);
    window.addEventListener('storage', handleStorage);

    return () => {
      window.removeEventListener(AMAZON_STORE_UPDATED_EVENT, handleStoreUpdated);
      window.removeEventListener('storage', handleStorage);
    };
  }, []);

  const currentStore = useMemo(() => getAmazonStoreDetails(amazonStoreState.region), [amazonStoreState.region]);
  const selectedValue = amazonStoreState.source === 'manual' ? currentStore.region : AUTO_VALUE;
  const autoLabel = `🌐 Auto · ${currentStore.selectorLabel}`;

  const handleChange = event => {
    const { value } = event.target;

    if (value === AUTO_VALUE) {
      trackEventIfConsented('amazon_store_select', {
        selection_mode: 'auto',
        store_region: currentStore.region,
      });
      clearAmazonStorePreference();
      return;
    }

    trackEventIfConsented('amazon_store_select', {
      selection_mode: 'manual',
      store_region: value,
    });
    setAmazonStorePreference(value);
  };

  return (
    <div className="amazon-store-selector">
      <div className="amazon-store-selector-field">
        <select
          id="amazon-store-selector-input"
          className="amazon-store-selector-input"
          value={selectedValue}
          onChange={handleChange}
          aria-label="Select location"
          title="Location"
        >
          <option value={AUTO_VALUE}>{autoLabel}</option>
          {AMAZON_SUPPORTED_REGIONS.map(region => {
            const storeOption = getAmazonStoreDetails(region);

            return (
              <option key={region} value={region}>
                {storeOption.selectorLabel}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};

export default AmazonStoreSelector;
